import { HStack, VStack } from '@sgme/ui';

import { InputGroup1 } from '@/App/tiles/TargetAccumulator/InputGroup1.tsx';
import { InputGroup2 } from '@/App/tiles/TargetAccumulator/InputGroup2.tsx';
import { InputGroup3 } from '@/App/tiles/TargetAccumulator/InputGroup3.tsx';
import { InputGroup4 } from '@/App/tiles/TargetAccumulator/InputGroup4.tsx';
import RightColumnHeader from '@/App/tiles/TargetAccumulator/RightColumnHeader.tsx';
import Summary from '@/App/tiles/TargetAccumulator/Summary.tsx';
import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { AccumulatorPayoffGraph } from '@/components/ui/AccumulatorPayoffGraph';

const PricerView = () => {
  const clientsWay = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.clientsWay);

  return (
    <VStack flex="expand" verticalAlignment="start" className="align-self-stretch">
      <RightColumnHeader />
      <HStack verticalAlignment="start" gap="24px" className="px-2">
        <div style={{ flexGrow: 0, width: 340 }}>
          <InputGroup1 />

          <div className="mt-3">
            <InputGroup2 />
          </div>

          <div className="mt-3">
            <InputGroup3 />
          </div>

          <div className="mt-3">
            <InputGroup4 />
          </div>
        </div>
        <VStack flex="expand">
          <Summary />
          <div className="mt-4" style={{ maxWidth: '300px' }}>
            <AccumulatorPayoffGraph
              productName="FxTargetAccumulator"
              way={clientsWay ?? 'Buy'}
              isAccumulatorTrigger={false}
            />
          </div>
        </VStack>
      </HStack>
    </VStack>
  );
};

export default PricerView;
